import { render, staticRenderFns } from "./ReviewGroupTournament.vue?vue&type=template&id=1c41d3c2&scoped=true"
import script from "./ReviewGroupTournament.vue?vue&type=script&lang=js"
export * from "./ReviewGroupTournament.vue?vue&type=script&lang=js"
import style0 from "./ReviewGroupTournament.vue?vue&type=style&index=0&id=1c41d3c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c41d3c2",
  null
  
)

export default component.exports